export default __webpack_public_path__ + "static/media/envira-logo-trademark.dfca3069.png";